/* Nordelia Cart Drawer v5 (4 nov: Winter-Set, Look Cordhose + Strick, Geschenk-drempel; v4: Sale-streepprijzen + staffel 2=−15 % / 3+=−20 %) – eigen winkelwagen, vervangt Kaching + Dawn drawer. */
(() => {
  if (customElements.get('cart-drawer')) return;
  const C = Object.assign(window.NDCart || {}, window.NDCartExtra || {});
  C.picks = Object.assign(C.picks || {}, C.picksPatch || {});
  const SG = Number(C.sorglos) || 0;
  const nf = window.fetch.bind(window);
  const fmt = (c) => (Number(c || 0) / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]);
  const img = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '');
  const short = (t) => String(t || '').split(' – ')[0];
  const ONE = /^(Einheitsgröße|Default Title|Onesize|One Size)$/i;
  const H = { Accept: 'application/json', 'Content-Type': 'application/json', 'X-ND': '1' };
  const api = (url, body) =>
    nf(url, body ? { method: 'POST', headers: H, body: JSON.stringify(body) } : { headers: H }).then(async (r) => {
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.description || j.message || 'Fehler');
      return j;
    });
  const pc = {}, pd = {};
  const getP = (h) => pc[h] || (pc[h] = nf('/products/' + h + '.js', { headers: { 'X-ND': '1' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null).then((p) => { pd[h] = p; return p; }));
  /* Echte streepprijs (compare_at_price) van de variant; /cart.js geeft die niet mee */
  const cmpOf = (it) => {
    const p = pd[it.handle];
    const v = p && (p.variants || []).find((x) => x.id === it.variant_id);
    return v && v.compare_at_price > it.original_price ? v.compare_at_price : 0;
  };
  const baseOf = (it) => { const c = cmpOf(it); return c ? c * it.quantity : it.original_line_price; };
  const inList = (k, h) => Array.isArray(C[k]) && C[k].includes(h);
  /* Fallback: lijsten via Ajax ophalen als Liquid ze leeg liet */
  const loadList = (k, coll) => (Array.isArray(C[k]) && C[k].length) ? Promise.resolve() :
    nf('/collections/' + coll + '/products.json?limit=250', { headers: { 'X-ND': '1' } }).then((r) => (r.ok ? r.json() : { products: [] }))
      .then((j) => { C[k] = (j.products || []).map((p) => p.handle); }).catch(() => {});
  const listsReady = Promise.all([loadList('cord', 'cordhosen-mengenrabatt'), loadList('cape', 'ponchos-capes'), loadList('jacket', 'jacken-mantel')]);
  const css = document.createElement('style');
  css.textContent = `.nd-fsg{display:flex;align-items:center;gap:10px;margin:0 0 10px;padding:10px 12px;border:1.5px solid rgba(31,36,33,.16);border-radius:10px;background:#fbfaf7;cursor:pointer;position:relative;transition:border-color .2s,background .2s}
.nd-fsg.is-on{border-color:#2f6b4f;background:#f1f7f3}
.nd-fsg__i svg{width:30px;height:30px;fill:#efe6dc;stroke:#1f352d;stroke-width:1.4;stroke-linejoin:round;display:block}.nd-fsg__i .nd-ck{fill:none;stroke:#2f6b4f;stroke-width:2.2}
.nd-fsg__b{flex:1;min-width:0;display:flex;flex-direction:column;line-height:1.3}
.nd-fsg__h{display:flex;flex-wrap:wrap;align-items:center;gap:2px 6px;font-size:14px;color:#1f2421}.nd-fsg__h b{white-space:nowrap}
.nd-fsg__l{font-size:12px;color:#545b56}.nd-fsg__l a{color:#6e746f}
.nd-fsg__p{font-size:14px;font-weight:800;color:#1f2421;white-space:nowrap}
.nd-fsg input{position:absolute;opacity:0;width:1px;height:1px;margin:0;pointer-events:none}
.nd-tg{flex:0 0 auto;position:relative;width:44px;height:26px;border-radius:999px;background:#c4c8c5;transition:background .2s}
.nd-tg:after{content:"";position:absolute;top:3px;left:3px;width:20px;height:20px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.3);transition:transform .2s}
.nd-fsg input:checked + .nd-tg{background:#2f6b4f}.nd-fsg input:checked + .nd-tg:after{transform:translateX(18px)}
.nd-fsg input:focus-visible + .nd-tg{outline:2px solid #1f352d;outline-offset:2px}`;
  document.head.appendChild(css);
  const O = C.offers || {};
  const isGift = (i) => !!(i.properties && i.properties._nd_gift);
  const kind = (it) => {
    const h = it.handle, t = it.product_type || '';
    if (inList('cord', h) || (/Hose|Jeans/i.test(t) && /cord/i.test(it.product_title || ''))) return 'cord';
    if (inList('cape', h) || /Poncho|Cape/i.test(t)) return 'cape';
    if (inList('jacket', h) || /Jacke|Mantel/i.test(t)) return 'jacket';
    if (inList('knit', h) || /Pullover|Strick|Pullunder|Cardigan/i.test(t)) return 'knit';
    if (inList('acc', h)) return 'acc';
    return 'other';
  };
  const oi = (p, re) => (p.options || []).findIndex((o) => re.test(o.name || o));
  const ov = (line, re) => ((line.options_with_values || []).find((o) => re.test(o.name)) || {}).value;
  const RE_C = /farbe|color|colour/i, RE_S = /größe|groesse|size/i;
  const ico = {
    bin: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>',
    box: '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M4 10l12-6 12 6v12l-12 6-12-6z"/><path d="M4 10l12 6 12-6M16 16v12"/><path d="M21 21.5l2 2 4-4.5" class="nd-ck"/></svg>',
  };

  class NDCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.panel = this.querySelector('.nd-cd__panel');
      this.body = this.querySelector('[data-nd-body]');
      this.foot = this.querySelector('[data-nd-foot]');
      this.sum = this.querySelector('[data-nd-sum]');
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('change', (e) => this.onChange(e));
      this.addEventListener('keyup', (e) => e.key === 'Escape' && this.close());
      const icon = document.getElementById('cart-icon-bubble');
      if (icon && !C.isCartPage) {
        icon.setAttribute('role', 'button');
        icon.setAttribute('aria-haspopup', 'dialog');
        icon.addEventListener('click', (e) => { e.preventDefault(); this.open(icon); });
      }
      const idle = window.requestIdleCallback || ((f) => setTimeout(f, 1200));
      idle(() => this.refresh().catch(() => {}));
    }
    /* Dawn-compatibel: product-form.js gebruikt deze drie */
    getSectionsToRender() { return []; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents() { this.queue(true); }

    queue(openAfter) {
      this._open = this._open || openAfter;
      clearTimeout(this._t);
      this._t = setTimeout(() => {
        const o = this._open; this._open = false;
        this.refresh().then(() => o && this.open()).catch(() => o && this.open());
      }, 60);
    }
    open(trigger) {
      if (trigger) this.activeElement = trigger;
      if (!this.cart) this.refresh().catch(() => {});
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      setTimeout(() => this.panel && this.panel.focus({ preventScroll: true }), 50);
    }
    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      this.activeElement && this.activeElement.focus && this.activeElement.focus({ preventScroll: true });
    }
    busy(on) { this.classList.toggle('is-busy', !!on); }
    err(msg) {
      const box = this.querySelector('[data-nd-err]');
      if (!box) return;
      box.textContent = msg; box.hidden = false;
      clearTimeout(this._et); this._et = setTimeout(() => (box.hidden = true), 4000);
    }

    async refresh() {
      let cart = await api('/cart.js');
      const sg = cart.items.find((i) => i.variant_id === SG);
      const real = cart.items.filter((i) => i.variant_id !== SG);
      const gift = cart.items.find(isGift);
      if (gift) {
        const rest = cart.items.filter((i) => i !== gift && i.variant_id !== SG).reduce((n, i) => n + i.final_line_price, 0);
        if (!O.gift || rest < (C.giftMin || 0)) cart = await api('/cart/change.js', { id: gift.key, quantity: 0 });
      }
      if (sg && !real.length) cart = await api('/cart/change.js', { id: sg.key, quantity: 0 });
      else if (sg && sg.quantity > 1) cart = await api('/cart/change.js', { id: sg.key, quantity: 1 });
      this.render(cart);
      return cart;
    }
    async run(p) {
      this.busy(true);
      try { await p; await this.refresh(); }
      catch (e) { await this.refresh().catch(() => {}); this.err(e.message || 'Das hat leider nicht geklappt.'); }
      finally { this.busy(false); }
    }
    add(id, qty = 1, properties) { return this.run(api('/cart/add.js', { items: [{ id: Number(id), quantity: qty, ...(properties ? { properties } : {}) }] })); }
    change(key, qty) { return this.run(api('/cart/change.js', { id: key, quantity: qty })); }

    render(cart) {
      this.cart = cart;
      const items = cart.items.filter((i) => i.variant_id !== SG);
      const sg = cart.items.find((i) => i.variant_id === SG);
      const count = items.reduce((n, i) => n + i.quantity, 0);
      this.querySelectorAll('[data-nd-count]').forEach((el) => (el.textContent = count ? '(' + count + ')' : ''));
      const bub = document.getElementById('cart-icon-bubble');
      if (bub) {
        let c = bub.querySelector('.dv-cart-count');
        if (count && !c) { c = document.createElement('span'); c.className = 'dv-cart-count'; bub.appendChild(c); }
        if (c) { if (count) c.textContent = count; else c.remove(); }
        bub.setAttribute('aria-label', 'Warenkorb' + (count ? ', ' + count + ' Artikel' : ''));
      }
      this.classList.toggle('is-empty', !count);
      if (!count) {
        this.body.innerHTML = `<div class="nd-empty"><p class="nd-empty__t">Ihr Warenkorb ist noch leer.</p><p>Cordhosen: 2 Stück −15 %, ab 3 Stück −20 % auf alle.</p><a class="nd-cta" href="${esc(C.cordUrl || '/collections/all')}">Cordhosen entdecken</a><a class="nd-link" href="/collections/all">Alle Produkte</a></div>`;
        this.foot.hidden = true;
        return;
      }
      this.foot.hidden = false;
      const lines = items.map((it) => this.line(it)).join('');
      this.body.innerHTML = `<div class="nd-err" data-nd-err hidden role="alert"></div><div class="nd-lines">${lines}</div><div data-nd-slot></div><div data-nd-ups></div>`;

      const orig = items.reduce((n, i) => n + baseOf(i), 0);
      const itemsFinal = items.reduce((n, i) => n + i.final_line_price, 0);
      const cartLevel = Math.max(0, Number(cart.items_subtotal_price || 0) - Number(cart.total_price || 0));
      const disc = Math.max(0, orig - itemsFinal) + cartLevel;
      const pct = orig && disc > 0 ? Math.round((disc / orig) * 100) : 0;
      this.sum.innerHTML = this.sorglos(sg) + `<div class="nd-tot"><div class="nd-tot__l"><b>Gesamt</b><small>inkl. MwSt. · <span class="nd-free">Versand kostenlos</span></small></div><div class="nd-tot__r">${pct ? `<span class="nd-save">Sie sparen ${pct} %</span>` : ''}<span class="nd-tot__p">${pct ? `<s>${fmt(cart.total_price + disc)}</s>` : ''}<b>${fmt(cart.total_price)}</b></span></div></div>`;
      this.extras(items);
      const missing = items.filter((i) => !(i.handle in pd));
      if (missing.length) Promise.all(missing.map((i) => getP(i.handle))).then(() => { if (this.cart === cart) this.render(cart); });
    }

    line(it) {
      const base = baseOf(it), sale = cmpOf(it) > 0;
      const d = base - it.final_line_price;
      const pct = d > 0 ? Math.round((d / base) * 100) : 0;
      const opts = (it.options_with_values || []).map((o) => o.value).filter((v) => !ONE.test(v)).join(' · ');
      const dt = isGift(it) ? 'Ihr Geschenk' : ((it.discounts || []).find((x) => x.title) || {}).title || '';
      return `<div class="nd-li" data-key="${esc(it.key)}"><a class="nd-li__img" href="${esc(it.url)}"><img src="${esc(img(it.image, 220))}" alt="" loading="lazy"></a><div class="nd-li__b"><div class="nd-li__top"><a class="nd-li__t" href="${esc(it.url)}">${esc(short(it.product_title))}</a><button type="button" class="nd-ibtn" data-nd-rm aria-label="Entfernen">${ico.bin}</button></div>${opts ? `<p class="nd-li__o">${esc(opts)}</p>` : ''}${pct ? `<p class="nd-li__d"><span class="nd-pill nd-pill--ok">−${pct} %</span>${esc(dt ? (/^Cordhosen/i.test(dt) ? 'Mengenrabatt' : dt.replace(/\s*[−-]\s*\d+\s*%.*$/, '')) + (sale ? ' + Herbst-Sale' : '') : (sale ? 'Herbst-Sale' : 'Rabatt'))}</p>` : ''}<div class="nd-li__bot"><div class="nd-qty"><button type="button" data-nd-q="-1" aria-label="Weniger">−</button><span aria-live="polite">${it.quantity}</span><button type="button" data-nd-q="1" aria-label="Mehr">+</button></div><div class="nd-li__pr">${pct ? `<s>${fmt(base)}</s>` : ''}<b>${fmt(it.final_line_price)}</b></div></div></div></div>`;
    }

    sorglos(sg) {
      if (!SG) return '';
      const on = !!sg;
      return `<label class="nd-fsg${on ? ' is-on' : ''}"><span class="nd-fsg__i">${ico.box}</span><span class="nd-fsg__b"><span class="nd-fsg__h"><b>Sorglos-Rückgabe</b><span class="nd-pill">Empfohlen</span></span><span class="nd-fsg__l">Rücksendung & Größentausch kostenlos · <a href="/products/${esc(C.sorglosHandle || 'sorglos-rueckgabe')}" target="_blank" rel="noopener">Details</a></span></span><span class="nd-fsg__p">${fmt(C.sorglosPrice || 395)}</span><input type="checkbox" role="switch" data-nd-sg ${on ? 'checked' : ''} aria-label="Sorglos-Rückgabe für 3,95 € hinzufügen"><span class="nd-tg" aria-hidden="true"></span></label>`;
    }

    async extras(items) {
      const token = (this._tok = {});
      await listsReady;
      const handles = items.map((i) => i.handle);
      const kinds = items.map(kind);
      const has = (k) => kinds.includes(k);
      const cordQty = items.filter((i) => kind(i) === 'cord').reduce((n, i) => n + i.quantity, 0);
      let deal = '';
      const shown = new Set(handles);

      if (cordQty === 1 || cordQty === 2) {
        const cl = items.filter((i) => kind(i) === 'cord');
        const line = cl[cl.length - 1];
        const have = cl.filter((i) => i.handle === line.handle).map((i) => ov(i, RE_C));
        const p = await getP(line.handle);
        if (cordQty === 2) deal = `<p class="nd-ok">✓ −15 % auf beide Cordhosen aktiv</p>`;
        if (p) deal += this.dealCard(p, line, cordQty, have);
      } else if (cordQty >= 3) {
        deal = `<p class="nd-ok">✓ −20 % auf alle Cordhosen aktiv</p>`;
      }
      let rollHtml = '';
      if (has('cape') && !handles.some((h) => inList('roll', h))) {
        const rs = (await Promise.all((C.roll || []).slice(0, 4).map(getP))).filter(Boolean).filter((p) => p.available).slice(0, 2);
        rs.forEach((p) => shown.add(p.handle));
        if (rs.length) rollHtml = `<div class="nd-box"><p class="nd-box__h"><span class="nd-pill nd-pill--hot">−15 %</span><b>Look: Rollkragen zum Cape</b></p>${rs.map((p) => this.upCard(p, '')).join('')}</div>`;
      }
      /* Winter-Set: accessoire in de wagen → tweede/derde teil voorstellen */
      let setHtml = '';
      const accItems = items.filter((i) => kind(i) === 'acc' && !isGift(i));
      const accQty = accItems.reduce((n, i) => n + i.quantity, 0);
      if (O.set && accQty >= 1) {
        if (accQty >= 3) setHtml = `<p class="nd-ok">✓ Winter-Set: −20 % aktiv</p>`;
        else {
          const have = new Set(accItems.map((i) => i.handle));
          const hs = (C.acc || []).filter((h) => !have.has(h)).slice(0, 8);
          const rs = (await Promise.all(hs.map(getP))).filter(Boolean).filter((p) => p.available).slice(0, 2);
          rs.forEach((p) => shown.add(p.handle));
          const n = accQty === 1 ? 2 : 3, pc = n === 2 ? 10 : 20;
          if (rs.length) setHtml = `${accQty === 2 ? '<p class="nd-ok">✓ Winter-Set: −10 % aktiv</p>' : ''}<div class="nd-box"><p class="nd-box__h"><span class="nd-pill nd-pill--hot">−${pc} %</span><b>Winter-Set: ${n}. Teil dazu</b></p><p class="nd-deal__s">Mit ${n} Accessoires sparen Sie ${pc} % auf alle.</p>${rs.map((p) => this.upCard(p, '')).join('')}</div>`;
        }
      }
      /* Look: Cordhose in de wagen, nog geen strick → strick met −15 % */
      let lookHtml = '';
      if (O.look && has('cord') && !has('knit')) {
        const rs = (await Promise.all((C.lookKnit || []).map(getP))).filter(Boolean).filter((p) => p.available).slice(0, 2);
        rs.forEach((p) => shown.add(p.handle));
        if (rs.length) lookHtml = `<div class="nd-box"><p class="nd-box__h"><span class="nd-pill nd-pill--hot">−15 %</span><b>Look: Strick zur Cordhose</b></p><p class="nd-deal__s">15 % auf ein Strickteil zu Ihrer Cordhose, automatisch im Warenkorb.</p>${rs.map((p) => this.upCard(p, '')).join('')}</div>`;
      }
      /* Bestaande Look-Rabatt zichtbaar maken: jas in de wagen, nog geen Cordhose */
      if (has('jacket') && !has('cord')) {
        const rs = (await Promise.all((C.lookCord || []).map(getP))).filter(Boolean).filter((p) => p.available).slice(0, 2);
        rs.forEach((p) => shown.add(p.handle));
        if (rs.length) lookHtml = `<div class="nd-box"><p class="nd-box__h"><span class="nd-pill nd-pill--hot">−15 %</span><b>Look: Cordhose zur Jacke</b></p><p class="nd-deal__s">15 % auf eine Cordhose zu Ihrer Jacke, automatisch im Warenkorb.</p>${rs.map((p) => this.upCard(p, '')).join('')}</div>`;
      }
      /* Geschenk vanaf drempel (kleurkeuze), alleen als de actie aan staat */
      let giftHtml = '';
      if (O.gift && C.giftHandle) {
        const gp = await getP(C.giftHandle);
        const hasGift = items.some(isGift);
        const rest = items.filter((i) => !isGift(i)).reduce((n, i) => n + i.final_line_price, 0);
        const min = C.giftMin || 0;
        if (gp && gp.available && !hasGift) {
          shown.add(gp.handle);
          if (rest >= min) {
            const vs = gp.variants.filter((v) => v.available);
            giftHtml = `<div class="nd-gift" data-nd-giftbox><b>Ihr Geschenk: ${esc(short(gp.title))}</b> (Wert ${fmt(gp.price)})<div class="nd-up__r"><select class="nd-sel" data-nd-gv aria-label="Farbe">${vs.map((v) => `<option value="${v.id}">${esc((v.title || '').split(' / ')[0])}</option>`).join('')}</select><button type="button" class="nd-add nd-add--solid" data-nd-gift>Gratis hinzufügen</button></div></div>`;
          } else if (rest >= min * 0.4) {
            giftHtml = `<div class="nd-gift">Noch <b>${fmt(min - rest)}</b> bis zu Ihrem Geschenk: ${esc(short(gp.title))} (Wert ${fmt(gp.price)})<div class="nd-gift__bar"><i style="width:${Math.round((rest / min) * 100)}%"></i></div></div>`;
          }
        }
      }
      const P = C.picks || {};
      let pool = [];
      if (has('jacket')) pool = pool.concat(P.jacket || []);
      if (has('knit')) pool = pool.concat(P.knit || []);
      if (has('cord')) pool = pool.concat(P.cord || []);
      if (has('cape')) pool = pool.concat(P.cape || []);
      if (has('acc') && !has('cord')) pool = pool.concat(P.acc || []);
      pool = pool.concat(P.other || []);
      const picks = [];
      for (const h of pool) {
        if (picks.length >= 2) break;
        if (shown.has(h) || picks.some((p) => p.handle === h)) continue;
        const p = await getP(h);
        if (p && p.available) { picks.push(p); shown.add(h); }
      }
      if (token !== this._tok) return;
      const dEl = this.querySelector('[data-nd-slot]');
      const uEl = this.querySelector('[data-nd-ups]');
      if (dEl) dEl.innerHTML = giftHtml + deal + setHtml + lookHtml + rollHtml;
      if (uEl && picks.length) {
        const badge = (p) => (has('jacket') && inList('cord', p.handle) ? 'Mit Jacke −15 %' : '');
        uEl.innerHTML = `<div class="nd-box nd-box--plain"><p class="nd-box__h"><b>Passt dazu</b></p>${picks.map((p) => this.upCard(p, badge(p))).join('')}</div>`;
      }
    }

    upCard(p, badge) {
      const vs = (p.variants || []).filter((v) => v.available);
      if (!vs.length) return '';
      const name = (v) => (v.title || '').split(' / ').filter((x) => !ONE.test(x)).join(' · ') || 'Standard';
      const sel = vs.length > 1
        ? `<select class="nd-sel" data-nd-v aria-label="Variante">${vs.map((v) => `<option value="${v.id}" data-p="${v.price}">${esc(name(v))}</option>`).join('')}</select>`
        : `<input type="hidden" data-nd-v value="${vs[0].id}">`;
      return `<div class="nd-up"><a class="nd-up__img" href="/products/${esc(p.handle)}"><img src="${esc(img(p.featured_image, 160))}" alt="" loading="lazy"></a><div class="nd-up__b"><a class="nd-up__t" href="/products/${esc(p.handle)}">${esc(short(p.title))}</a><p class="nd-up__p"><b data-nd-price>${fmt(vs[0].price)}</b>${badge ? `<span class="nd-pill nd-pill--hot">${esc(badge)}</span>` : ''}</p><div class="nd-up__r">${sel}<button type="button" class="nd-add" data-nd-add>+ Hinzufügen</button></div></div></div>`;
    }

    dealCard(p, line, n = 1, have = []) {
      const ci = oi(p, RE_C), si = oi(p, RE_S);
      if (ci < 0) return '';
      const curC = ov(line, RE_C), curS = ov(line, RE_S);
      const colors = (p.options[ci].values || []).filter((c) => c !== curC && !have.includes(c));
      const chips = colors.map((c) => {
        const vv = p.variants.filter((v) => v['option' + (ci + 1)] === c);
        if (!vv.some((v) => v.available)) return '';
        const im = (vv.find((v) => v.featured_image) || {}).featured_image;
        return `<button type="button" class="nd-chip" data-nd-c="${esc(c)}">${im ? `<img src="${esc(img(im.src, 120))}" alt="" loading="lazy">` : '<i></i>'}<span>${esc(c)}</span></button>`;
      }).filter(Boolean);
      if (!chips.length) return '';
      chips[0] = chips[0].replace('class="nd-chip"', 'class="nd-chip is-sel" aria-pressed="true"');
      const sizes = si >= 0 ? (p.options[si].values || []) : [];
      const sizeSel = sizes.length > 1
        ? `<select class="nd-sel" data-nd-s aria-label="Größe">${sizes.map((s) => `<option${s === curS ? ' selected' : ''}>${esc(s)}</option>`).join('')}</select>` : '';
      this._deal = { p, ci, si };
      return `<div class="nd-deal"><p class="nd-box__h"><span class="nd-pill nd-pill--hot">${n === 1 ? '−15 %' : '−20 %'}</span><b>${n === 1 ? '2 Cordhosen: −15 % auf beide' : '3 Cordhosen: −20 % auf alle'}</b></p><p class="nd-deal__s">${n === 1 ? 'Gleiche Hose in einer zweiten Farbe – der Rabatt gilt automatisch für beide Hosen.' : 'Mit einer dritten Hose sparen Sie 20 % auf alle Cordhosen im Warenkorb.'}</p><div class="nd-chips">${chips.join('')}</div><div class="nd-deal__r">${sizeSel}<button type="button" class="nd-add nd-add--solid" data-nd-deal>+ ${n === 1 ? 'Zweite' : 'Dritte'} Hose hinzufügen</button></div></div>`;
    }

    onClick(e) {
      const t = e.target;
      if (t.closest('[data-nd-close]')) return this.close();
      const li = t.closest('.nd-li');
      if (li && t.closest('[data-nd-rm]')) return this.change(li.dataset.key, 0);
      const q = t.closest('[data-nd-q]');
      if (li && q) {
        const it = this.cart.items.find((i) => i.key === li.dataset.key);
        return it && this.change(it.key, Math.max(0, it.quantity + Number(q.dataset.ndQ)));
      }
      const chip = t.closest('.nd-chip');
      if (chip) {
        chip.parentElement.querySelectorAll('.nd-chip').forEach((c) => { c.classList.remove('is-sel'); c.removeAttribute('aria-pressed'); });
        chip.classList.add('is-sel'); chip.setAttribute('aria-pressed', 'true');
        return;
      }
      if (t.closest('[data-nd-deal]') && this._deal) {
        const { p, ci, si } = this._deal;
        const box = t.closest('.nd-deal');
        const c = (box.querySelector('.nd-chip.is-sel') || {}).dataset?.ndC;
        const s = (box.querySelector('[data-nd-s]') || {}).value;
        const v = p.variants.find((v) => v['option' + (ci + 1)] === c && (si < 0 || !s || v['option' + (si + 1)] === s) && v.available);
        if (!v) return this.err('Diese Größe ist in der Farbe gerade nicht verfügbar.');
        return this.add(v.id);
      }
      if (t.closest('[data-nd-gift]')) {
        const g = t.closest('[data-nd-giftbox]').querySelector('[data-nd-gv]');
        return g && this.add(g.value, 1, { _nd_gift: '1' });
      }
      if (t.closest('[data-nd-add]')) {
        const v = t.closest('.nd-up').querySelector('[data-nd-v]');
        return v && this.add(v.value);
      }
    }
    onChange(e) {
      const t = e.target;
      if (t.matches('[data-nd-sg]')) {
        const sg = this.cart && this.cart.items.find((i) => i.variant_id === SG);
        if (t.checked && !sg) return this.add(SG);
        if (!t.checked && sg) return this.change(sg.key, 0);
      }
      if (t.matches('select[data-nd-v]')) {
        const o = t.selectedOptions[0];
        const pr = t.closest('.nd-up').querySelector('[data-nd-price]');
        if (o && pr) pr.textContent = fmt(o.dataset.p);
      }
    }
  }
  customElements.define('cart-drawer', NDCartDrawer);

  /* Andere scripts (bundles, sticky ATC, apps) die de cart aanpassen → drawer verversen/openen */
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const h = init && init.headers;
    const mine = h && (h['X-ND'] || (typeof h.get === 'function' && h.get('X-ND')));
    const res = nf(input, init);
    if (!mine && /\/cart\/(add|change|update|clear)/.test(url)) {
      res.then((r) => {
        const d = document.querySelector('cart-drawer.nd-cd');
        if (d && r.ok) d.queue(/\/cart\/add/.test(url) && !C.isCartPage);
      }).catch(() => {});
    }
    return res;
  };
})();
